// -----------------------------
// User & Authentication Models
// -----------------------------
export interface User {
  userCode?: string;
  // Core identifiers
  id: number | string;               // supports both types based on backend
  email: string;

  // Name handling (supports both old and new structure)
  firstName?: string;
  lastName?: string;
  name?: string | any;                     // combined name from new model

  // Role handling
  role: UserRole | any;           // enum OR dynamic string role
  roleId?: number;                   // from new model

  // Provider & Location Metadata
  providerName?: string;
  providerId?: number;

  locationName?: string;
  locationId?: number;

  // Activity
  lastActivityDate?: Date;

  // Token (used after login)
  token?: string;
}

// -----------------------------
// User Roles Enum (kept for backward compatibility)
// -----------------------------
export enum UserRole {
  Super_Admin = 'Super Admin',
  App_Admin = 'App Admin',
  DME_Admin = 'DME Admin',
  DME_User = 'DME User',
  Technician = 'Technician',
  Patient = 'Patient',
  Caregiver = 'Caregiver',
  Admin = 'Admin'  
}

  // Role ID mapping for UserRole enum
  export const UserRoleIdMap: { [key in UserRole]: number } = {
    [UserRole.Super_Admin]: 1,
    [UserRole.App_Admin]: 2,
    [UserRole.DME_Admin]: 3,
    [UserRole.DME_User]: 4,
    [UserRole.Technician]: 5,
    [UserRole.Patient]: 6,
    [UserRole.Caregiver]: 7,
    [UserRole.Admin]: 8
  };

// -----------------------------
// Authentication Requests
// -----------------------------
export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  user: User;
  token: string;
}

// -----------------------------
// User Listing (New Additions)
// -----------------------------
export interface UserListRequest {
  pageNumber: number;
  pageSize: number;
  searchTerm?: string;

  providerId?: number;
  locationId?: number;
  roleId?: number;

  lastActivityDateStart?: Date;
  lastActivityDateEnd?: Date;
}

export interface UserListResponse {
  users: User[];
  totalCount: number;
  pageCount: number;
  currentPage: number;
  pageSize: number;
}

// -----------------------------
// User Creation / Update
// -----------------------------
export interface CreateUserRequest {
  name: string;
  email: string;
  roleId: number;
  providerId?: number;
  locationId?: number;
}

// -----------------------------
// Role, Provider & Location Models
// -----------------------------
export interface Role {
  id: number;
  name: string;
  description?: string;
  canAccessPortal: boolean;
}

export interface Provider {
  id: number;
  name: string;
}

export interface Location {
  id: number;
  name: string;
  providerId: number;
}
